import { Component, EventEmitter, Input, OnChanges, SimpleChanges, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { StarRatingModal } from './star-rating-modal/star-rating-modal';
import { StarRatingResult } from './star-rating-result';

@Component({
  selector: 'app-star-rating',
  standalone: true,
  imports: [CommonModule, TranslateModule, StarRatingModal],
  templateUrl: './star-rating.html',
  styleUrl: './star-rating.scss',
})
export class StarRating implements OnChanges {
  /** Current rating value (0–5). */
  @Input() value = 0;

  /** Incoming rating value from API; if provided, it overrides `value`. */
  @Input() rating: number | null = null;

  /** Existing comment to pre-fill in the modal. */
  @Input() comment = '';

  /** Whether the rating is read-only (no click). */
  @Input() readonly = false;

  /** Emits the confirmed rating and comment. */
  @Output() valueChange = new EventEmitter<StarRatingResult>();

  starsArray = [1, 2, 3, 4, 5];

  showModal = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['rating'] && this.rating !== null && this.rating !== undefined) {
      this.value = this.normalizeValue(this.rating);
    }
    if (changes['value'] && (this.rating === null || this.rating === undefined)) {
      this.value = this.normalizeValue(this.value);
    }
  }

  openModal(): void {
    if (this.readonly) return;
    this.showModal = true;
  }

  onConfirmed(result: StarRatingResult): void {
    this.value = this.normalizeValue(result.rating);
    this.valueChange.emit({
      rating: this.value,
      comment: result.comment ?? '',
    });
  }

  private normalizeValue(val: number): number {
    const clamped = Math.max(0, Math.min(5, Number(val) || 0));
    return Math.round(clamped);
  }
}
